import { FormProvider, useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import { DevTool } from "@hookform/devtools"
import schema from "./Validation"
import { Grid } from "@mui/material"
import { AcademicLevel, ConsentementMultiple, MentionsLegales, RequiredFields, Submit } from "components"
import { Email, InputText, PhoneNumber } from "components/fields"
import { consent, defaultValues } from "services"
import RendezVous from "../components/RendezVous"
import Programmes from "../components/Programmes"
import useLandingPage from "../services/useLandingPage"
import { academicLevelsRentreeDecalee, LAST_FORMS, PHONE_CALL } from "../services/landingPages"

// LP Rentrée décalée : campus de Paris uniquement
const Form = () => {
  const methods = useForm({
    defaultValues: {
      ...consent,
      rendezVous: PHONE_CALL,
      lead: {
        ...defaultValues,
        Campus__c: 'Paris',
        PGE__c: false,
        BMI__c: false
      }
    },
    resolver: yupResolver(schema)
  })
  const { control } = methods
  const { submit } = useLandingPage({
    campaignStatus: 'Contact Requested',
    formId: 'CONTACT',
    lastForm: LAST_FORMS.rentreeDecalee,
    leadSource: 'LP : Demande de contact',
    urlKey: 'ISG-LP-RENTREE-DECALEE'
  })

  const onSubmit = data => submit({ ...data, campusLabel: 'Paris' })

  return (
    <FormProvider {...methods}>
      <DevTool control={control} />
      <Grid container spacing={2}>
        <RendezVous campusLabel="le campus de Paris" />
        <Grid item sm={6} xs={12}>
          <InputText control={control} label="Prénom" name="lead.FirstName" required />
        </Grid>
        <Grid item sm={6} xs={12}>
          <InputText control={control} label="Nom" name="lead.LastName" required />
        </Grid>
        <Grid item sm={6} xs={12}>
          <Email control={control} label="Adresse e-mail" name="lead.Email" required />
        </Grid>
        <Grid item sm={6} xs={12}>
          <PhoneNumber control={control} name="lead.MobilePhone" label="Téléphone" required />
        </Grid>
        <AcademicLevel options={academicLevelsRentreeDecalee} section={false} specialites={false} />
        <Programmes programmes={[
          { name: 'lead.PGE__c', label: 'Programme Grande École en 5 ans' },
          { name: 'lead.BMI__c', label: 'Bachelor en Management International' }
        ]} />
        <ConsentementMultiple callOptIn />
        <RequiredFields />
        <Submit onSubmit={onSubmit} />
        <MentionsLegales form="Contact" school="ISG France" />
      </Grid>
    </FormProvider>
  )
}

export default Form
